// extracted by mini-css-extract-plugin
module.exports = {"privacyPolice_label":"page_privacyPolice_label__0iTPY","privacyPolice_text_item":"page_privacyPolice_text_item__9mmWh"};